import axios from "axios";
import { requiredParam } from "@utils/func";

const getCompanyDetails = ({ companyId = requiredParam("companyId") } = {}) => {
  return axios.get(`companies/${companyId}`);
};

const patchCompanyDetails = ({
  companyId = requiredParam("companyId"),
  dbKey = requiredParam("dbKey"),
  newValue = requiredParam("newValue"),
} = {}) => {
  return axios.patch(`companies/${companyId}`, { [`${dbKey}`]: newValue });
};

export { getCompanyDetails, patchCompanyDetails };
